import { ArrowDownOutlined } from '@ant-design/icons';
import cs from 'classnames';
import { type RefObject, useEffect, useMemo, useRef, useState, type Dispatch, type SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Button } from 'ui';

// TODO move somewhere else
function useIsInViewport({
  reference,
  onEnterViewPort,
}: {
  reference: RefObject<HTMLDivElement>;
  onEnterViewPort?: Dispatch<SetStateAction<boolean>>;
}) {
  const [isIntersecting, setIsIntersecting] = useState(false);

  const observer = useMemo(() => new IntersectionObserver(([entry]) => setIsIntersecting(entry.isIntersecting)), []);

  useEffect(() => {
    if (reference.current) {
      observer.observe(reference.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [reference, observer]);

  useEffect(() => {
    if (isIntersecting && onEnterViewPort) {
      onEnterViewPort(true);
    }
  }, [isIntersecting, onEnterViewPort]);

  return isIntersecting;
}

const ContinueReading = () => {
  const { t } = useTranslation();
  const [hidden, setHidden] = useState(false);
  const reference = useRef<HTMLDivElement>(null);
  useIsInViewport({ reference, onEnterViewPort: setHidden });

  return (
    <>
      <div ref={reference} />
      <Row
        item={{
          className: cs('continue-reading', { 'continue-reading__hidden': hidden }),
          align: 'middle',
          justify: 'center',
        }}
      >
        <Col>
          <Button item={{ type: 'link', className: 'continue-reading__button' }}>
            {t('Continue reading')} <ArrowDownOutlined />
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default ContinueReading;
